import { SvgIcon } from "@mui/material";

const FileCircleQuotation = props => {
  return (
    <SvgIcon viewBox="0 0 14 14" {...props}>
      {/* File top fold, same as your original */}
      <path d="M5.44446 3.88889V0L9.33335 3.88889H5.44446Z" />

      {/* Circular area with a quotation mark icon */}
      <path d="M7 8.94444C7 7.01215 8.56772 5.44444 10.5 5.44444C12.4323 5.44444 14 7.01215 14 8.94444C14 10.8767 12.4323 12.4444 10.5 12.4444C8.56772 12.4444 7 10.8767 7 8.94444Z" />
      <path d="M9.4 8.2C9.4 7.7 9.8 7.3 10.3 7.3C10.8 7.3 11.2 7.7 11.2 8.2C11.2 8.6 11.0 9.0 10.7 9.2V9.5C10.7 9.7 10.5 9.9 10.3 9.9C10.1 9.9 9.9 9.7 9.9 9.5V9.0C9.6 8.8 9.4 8.5 9.4 8.2ZM8.6 8.2C8.6 7.7 9.0 7.3 9.5 7.3C9.6 7.3 9.7 7.3 9.8 7.4C9.7 7.7 9.7 8.1 9.9 8.4C10.0 8.7 10.2 8.9 10.4 9.1V9.5C10.4 9.7 10.2 9.9 10.0 9.9C9.8 9.9 9.6 9.7 9.6 9.5V9.2C9.2 9.0 8.6 8.7 8.6 8.2Z" />

      {/* File body */}
      <path
        className="secondary"
        d="M0 1.55556C0 0.696354 0.696354 0 1.55556 0H5.44444V3.88889H9.33333V4.82708C7.53715 5.33507 6.22222 6.98542 6.22222 8.94444C6.22222 10.3809 6.92951 11.6497 8.01354 12.4274C7.93819 12.4372 7.85799 12.4444 7.77778 12.4444H1.55556C0.696354 12.4444 0 11.7469 0 10.8889V1.55556Z"
      />
    </SvgIcon>
  );
};

export default FileCircleQuotation;
